import { Card, CardContent } from '@/components/ui/Card'

interface Stat {
  label: string;
  value: string | number;
  sub: string;
}

interface DashboardKPIProps {
  stats: Stat[];
}

export function DashboardKPI({ stats }: DashboardKPIProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4">
      {stats.map(s => (
        <Card key={s.label}>
          <CardContent className="p-2">
            <div className={`text-sm font-semibold mb-2 text-zinc-500 dark:text-zinc-400`}>
              {s.label}
            </div>
            <div className={`text-3xl font-black text-zinc-700 dark:text-zinc-300`}>
              {s.value}
            </div>
            <div className={`text-sm mt-1.5  text-zinc-400 dark:text-zinc-500`}>
              {s.sub}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
